import { render, staticRenderFns } from "./ManagementOverview.vue?vue&type=template&id=6e839a22&scoped=true&lang=html&"
import script from "./ManagementOverview.vue?vue&type=script&lang=js&"
export * from "./ManagementOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e839a22",
  null
  
)

export default component.exports